import { INewsResponse } from '../api/NewsTypes';

/* REQUEST NEWS */
export const REQUEST_SHARE_NEWS_WAITING = 'REQUEST_SHARE_NEWS_WAITING';
export const REQUEST_SHARE_NEWS_SUCCESS = 'REQUEST_SHARE_NEWS_SUCCESS';
export const REQUEST_SHARE_NEWS_FAILURE = 'REQUEST_SHARE_NEWS_FAILURE';

interface IRequestShareNewsWaitingAction {
    type: typeof REQUEST_SHARE_NEWS_WAITING,
    payload: {
        symbol: string,
        tradingDay: string
    }
}

interface IRequestShareNewsSuccessAction {
    type: typeof REQUEST_SHARE_NEWS_SUCCESS,
    payload: {
        symbol: string,
        tradingDay: string,
        newsResponse: INewsResponse
    }
}

interface IRequestShareNewsFailureAction {
    type: typeof REQUEST_SHARE_NEWS_FAILURE,
    payload: {
        symbol: string,
        tradingDay: string,
        error: string
    }
}

export type NewsActions =
IRequestShareNewsWaitingAction
| IRequestShareNewsSuccessAction
| IRequestShareNewsFailureAction;